@if(redemption(); as use){
    
    <!-- REDEMPTION HEADER -->
    <div class="use-header p-inset py-8 px-8">
        <!-- BRAND -->
        <a class="use-brand" [routerLink]="['/brands', use.brand.slug]" [title]="use.brand.name">
            <img class="use-brand-logo" [src]="use.brand.logo_url | bucket:true" [alt]="use.brand.name" [fallback]/>
            <h4 class="my-0 ml-6 use-brand-title" paint="dark">{{use.brand.short || use.brand.name}}</h4>
        </a>
        <!-- SAVINGS -->
        <div class="use-savings">
            @if(use.actual_savings){
                <p class="my-0 font-semibold" paint="primary">+ €{{use.actual_savings}}</p>
                <small>&nbsp;</small>
            } @else if(canSeeEstimated()) {
                <p class="my-0 font-semibold" paint="light">+ €{{use.savings||0}}</p>
                <small paint="light">Estimated</small>
            }
        </div>
    </div>
    <!-- REDEMPTION BODY (TITLE, USAGE DATE, PLAN) -->
    <a class="use-body p-inset px-8" [routerLink]="use.status && use.brand.status ? ['/brands', use.brand.slug, 'offers', use.url] : null">
        <!-- TITLE -->
        <h3 class="mt-0 mb-2" paint="dark">
            {{use.short_title}}
        </h3>
        <div class="use-info">
            <!-- REDEMPTION DATE -->
            <small paint="dark">{{use.redeemed | date: 'dd/MM/yyyy - hh:mm a'}}</small>
            <!-- REDEMPTION FROM PLAN -->
            @if(use.plan){
                <small class="ml-4 use-plan py-2 px-8 display-flex f-cross-center">
                    @if(use.userinterval == 'upgrade'){
                        <mat-icon class="sized mr-2" style="--icon-size: 14px; margin-top: -1px; margin-left: -4px;" svgIcon="star"></mat-icon>
                    }
                    <span>
                        {{use.plan | humanize}}
                    </span>
                </small>
            }
        </div>
    </a>
    <!-- EDIT CONTROLS -->
    <div class="use-footer p-inset px-8 my-2">
        @if(editable() == 'add'){
            <button type="button" class="accent-horizontal py-4 pl-12 pr-6 use-edit display-flex f-main-between f-cross-center interactive w-full p-inset" (click)="edit()">
                <span>Missing Savings</span>
                <div class="display-flex f-cross-center">
                    <span class="font-bold">ADD NOW</span>
                    <mat-icon class="ml-4">chevron_right</mat-icon>
                </div>
            </button>
        }
        @else if(editable() =='edit'){
            <button type="button" class="use-plan py-6 px-12 use-edit display-flex f-cross-center interactive" (click)="edit()">
                <mat-icon class="sized mr-4" style="--icon-size: 18px;">edit</mat-icon>
                <span>Edit Savings</span>
            </button>
        }
    </div>
} @else {
    <!-- TODO: SKELETON -->
}
